import * as helper from './../../../../../VX/View/Assets/Js/helper';
import AlertBox from './AlertBox';

export default class Section4 {
	constructor() {
		this.land = helper.$('#country');
		this.city = helper.$('#inputZip');
		this.alertBox = new AlertBox(helper.$('#section4'));
	}

	get values() {
		return {
			'region' : this.city.value
		};
	}

	isValid() {
		if (this.city.value !== '') {
			helper.removeClass(this.city, 'alertborder');
			this.alertBox.hide();
			return true;
		}

		helper.addClass(this.city, 'alertborder');
		this.alertBox.show('Bitte gib deine Postleitzahl ein!');
		return false;
	}
}
